import { Box, IconButton, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from "@mui/material"
import { FILE_PATH_URI, handleDownload } from "../../../../utils/helper"
import SkeletonImage from "../../../../components/common/SkeletonImage"
import DocViewer from "../../../../components/common/DocViewer"
import Icons from "../../../../assets/js/Icons"
import { Fragment } from "react"

function Expertise({ expertise }) {
  return (
    <Fragment>
      <Typography sx={{ fontSize: "24px", fontWeight: "600" }}>User Expertise</Typography>
      <TableContainer
        className="adminTable2"
      // sx={{ "tr:last-child :is(td, th)": { borderBottom: "none" } }}
      >
        <Table stickyHeader>
          <TableBody>
            <TableRow>
              <TableCell component="th">Specialization</TableCell>
              <TableCell>{expertise?.specialization?.name}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th">Years of experience</TableCell>
              <TableCell>{expertise?.experience}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th">Certifications and Qualifications</TableCell>
              <TableCell sx={{ whiteSpace: "normal !important" }}>
                {expertise?.qualifications}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th">Certification Documents</TableCell>
              <TableCell>
                <Box
                  sx={{
                    width: "250px",
                    borderRadius: 2,
                    overflow: "hidden",
                    aspectRatio: "1/1",
                    position: "relative",
                    display: "inline-block",
                  }}
                >
                  {expertise?.certificate?.[0]?.path &&
                    <IconButton
                      sx={{
                        top: "10px",
                        right: "10px",
                        border: "1px solid",
                        position: "absolute",
                        color: "primary.main",
                        bgcolor: "white !important",
                        borderColor: "primary.main"
                      }}
                      size="small"
                      onClick={() => { handleDownload(FILE_PATH_URI + expertise?.certificate?.[0]?.path) }}
                    ><Icons.CloudDownloadSolid />
                    </IconButton>
                  }
                  <SkeletonImage src={FILE_PATH_URI + expertise?.certificate?.[0]?.path} />
                </Box>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <DocViewer />
    </Fragment>
  )
}

export default Expertise